// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1HUMp","log":"ModalInventoryLogs_log__18RA0","date":"ModalInventoryLogs_date__2smwm","userName":"ModalInventoryLogs_userName__T6WUN"};